// contact page faq js with view more /less limit
document.addEventListener("DOMContentLoaded", function() {
  if (!window.location.pathname.includes("/pages/contact")) return;
  var faqs = document.querySelectorAll("accordion-custom details");
  if (!faqs.length) return;
  var limit = 2;
  var expanded = false;
  faqs.forEach(function(faq, index) {
    if (index >= limit) {
      faq.style.display = "none";
    }
  });
  var btn = document.querySelector(".faq-view-more-btn");
  if (!btn) return;
  btn.addEventListener("click", function() {
    expanded = !expanded;
    faqs.forEach(function(faq, index) {
      if (index >= limit) {
        faq.style.display = expanded ? "block" : "none";
      }
    });
    btn.innerText = expanded ? "View Less FAQs" : "View More FAQs";
  });
});

// class for product card content except product media
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".product-card__content").forEach(function(card) {
    var media = card.querySelector(".card-gallery");
    if (!media) return;
    var wrapper = document.createElement("div");
    wrapper.className = "custom-product-content";
    var next = media.nextElementSibling;
    while (next) {
      var current = next;
      next = next.nextElementSibling;
      wrapper.appendChild(current);
    }
    media.after(wrapper);
  });
});

//flavour dropdown js for product page
(function() {

 
function moveDropdown() {
  var dropdown = document.querySelector('.flavour-selector');
  var buyButtons = document.querySelector('.buy-buttons-block');
  if (dropdown && buyButtons) {
    buyButtons.parentNode.insertBefore(dropdown, buyButtons);
    dropdown.style.visibility = 'visible';
    return;
  }
  if (dropdown) dropdown.style.visibility = 'visible';
  var observer = new MutationObserver(function(_, obs) {
    var d = document.querySelector('.flavour-selector');
    var b = document.querySelector('.buy-buttons-block');
    if (d) d.style.visibility = 'visible';
    if (d && b) { b.parentNode.insertBefore(d, b); obs.disconnect(); }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function() { observer.disconnect(); }, 3000);
}

  function wrapTitleAndTags() {
    var tags = document.querySelector('.custom-tag-main--details');
    var titleBlock = document.querySelector('.text-block h2, .text-block h1');
    if (tags && titleBlock) {
      if (tags.closest('.title-tags-wrapper')) return;
      var titleParent = titleBlock.closest('.text-block');
      var wrapper = document.createElement('div');
      wrapper.className = 'title-tags-wrapper';
      tags.parentNode.insertBefore(wrapper, tags);
      wrapper.appendChild(tags);
      wrapper.appendChild(titleParent);
      return;
    }
    var observer = new MutationObserver(function(_, obs) {
      var t = document.querySelector('.custom-tag-main--details');
      var tb = document.querySelector('.text-block h2, .text-block h1');
      if (t && tb) {
        if (t.closest('.title-tags-wrapper')) { obs.disconnect(); return; }
        var tp = tb.closest('.text-block');
        var w = document.createElement('div');
        w.className = 'title-tags-wrapper';
        t.parentNode.insertBefore(w, t);
        w.appendChild(t);
        w.appendChild(tp);
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 3000);
  }

  function syncSelectToPage() {
    var selects = document.querySelectorAll('[data-flavour-select]');
    selects.forEach(function(select) {
      var currentPath = window.location.pathname;
      var matched = false;
      Array.from(select.options).forEach(function(opt) {
        try {
          var optPath = new URL(opt.value, window.location.origin).pathname;
          if (optPath === currentPath) {
            opt.selected = true;
            matched = true;
          } else {
            opt.selected = false;
          }
        } catch(e) {}
      });
      if (!matched && select.options.length > 0) {
        select.options[0].selected = true;
      }
    });
  }

  function updatePage(html, url, pushHistory) {
    var parser = new DOMParser();
    var newDoc = parser.parseFromString(html, 'text/html');
    if (pushHistory) {
      window.history.pushState({ flavourNavigation: true, url: url }, newDoc.title, url);
    }
    document.title = newDoc.title;
    var currentMain = document.querySelector('main');
    var newMain = newDoc.querySelector('main');
    if (currentMain && newMain) {
      document.querySelectorAll('body > .refil-lb').forEach(function(el) {
        el.remove();
      });

      var newTags = newMain.querySelector('.custom-tag-main--details');
      var newTitleBlock = newMain.querySelector('.text-block h2, .text-block h1');
      if (newTags && newTitleBlock) {
        var newTitleParent = newTitleBlock.closest('.text-block');
        if (!newTags.closest('.title-tags-wrapper')) {
          var newWrapper = document.createElement('div');
          newWrapper.className = 'title-tags-wrapper';
          newTags.parentNode.insertBefore(newWrapper, newTags);
          newWrapper.appendChild(newTags);
          newWrapper.appendChild(newTitleParent);
        }
      }
      

      currentMain.innerHTML = newMain.innerHTML;
      initAll();
      moveDropdown();

  currentMain.querySelectorAll('.rl-ticker-wrap').forEach(function(root) {
    // Cancel stale rAF loop
  if (root._rafId) { cancelAnimationFrame(root._rafId); root._rafId = null; }
  // Cancel stale window listeners
  if (root._dragController) root._dragController.abort();
  root._dragController = new AbortController();
  var signal = root._dragController.signal;
    var track = root.querySelector('.rl-tk-track');
    var prevBtn = root.querySelector('.rl-tk-prev-btn');
    var nextBtn = root.querySelector('.rl-tk-next-btn');
    if (!track || !prevBtn || !nextBtn) return;

    track.style.animation = 'none';

    var pos = 0;
    var targetPos = 0;
    var isSliding = false;
    var lastTime = null;

    function half() { return track.scrollWidth / 2; }
    function slideW() { 
      var s = track.querySelector('.rl-tk-slide'); 
      return s ? s.offsetWidth + 16 : 200; 
    }

    function tick(ts) {
      if (!lastTime) { lastTime = ts; root._rafId = requestAnimationFrame(tick); return; }
      var dt = Math.min((ts - lastTime) / 1000, 0.05);
      lastTime = ts;
      var h = half();
      if (h <= 0) { root._rafId = requestAnimationFrame(tick); return; }

      if (!isSliding) {
        pos += (h / 30) * dt;
        if (pos >= h) pos -= h;
        targetPos = pos;
        track.style.transform = 'translateX(-' + pos + 'px)';
      } else {
        var diff = targetPos - pos;
        pos += diff * 0.2;
        var displayPos = ((pos % h) + h) % h;
        track.style.transform = 'translateX(-' + displayPos + 'px)';
        if (Math.abs(diff) < 0.5) {
          pos = ((pos % h) + h) % h;
          targetPos = pos;
          isSliding = false;
        }
      }
      root._rafId = requestAnimationFrame(tick);
    }

    root._rafId = requestAnimationFrame(tick);

    prevBtn.addEventListener('click', function() {
      var h = half(), sw = slideW() * 4;
      targetPos = pos - sw;
      if (targetPos < 0) targetPos += h;
      isSliding = true;
    });

    nextBtn.addEventListener('click', function() {
      var h = half(), sw = slideW() * 4;
      targetPos = pos + sw;
      if (targetPos >= h) targetPos -= h;
      isSliding = true;
    });
  });
    } else {
      window.location.href = url;
    }
  }
  function fetchAndUpdate(url, pushHistory) {
    return fetch(url)
      .then(function(response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function(html) {
        updatePage(html, url, pushHistory);
      })
      .catch(function(err) {
        console.error('[FlavourSelector] Failed:', err);
        window.location.href = url;
      });
  }

  function initFlavourSelect(el) {
    el.dataset.flavourInit = 'true';
    el.addEventListener('change', function() {
      var url = el.value;
      if (!url) return;
      var wrapper = el.closest('[data-flavour-selector]');
      if (wrapper) wrapper.style.opacity = '0.5';
      el.disabled = true;
      fetchAndUpdate(url, true).then(function() {
        if (wrapper) wrapper.style.opacity = '1';
        el.disabled = false;
      });
    });
  }

  function initAll() {
    syncSelectToPage();
    document.querySelectorAll('[data-flavour-select]').forEach(function(el) {
      if (!el.dataset.flavourInit) {
        initFlavourSelect(el);
      }
    });
  }

  window.history.replaceState(
    { flavourNavigation: true, url: window.location.href },
    document.title,
    window.location.href
  );

  window.addEventListener('popstate', function(e) {
    if (e.state && e.state.flavourNavigation) {
      var url = e.state.url || window.location.href;
      fetchAndUpdate(url, false).then(function() {
        moveDropdown();
        setTimeout(function() {
        wrapTitleAndTags();
      }, 300);
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll();
      moveDropdown();
      wrapTitleAndTags();
    });
  } else {
    initAll();
    moveDropdown();
    wrapTitleAndTags();
  }

  document.addEventListener('shopify:section:load', function() {
    initAll();
    moveDropdown();
    wrapTitleAndTags();
     setTimeout(function() {
    wrapTitleAndTags();
  }, 300);
  });

})();

// Lightbox event delegation - works on page load AND after flavour change
document.addEventListener('click', function(e) {

  // Grid image click — open lightbox at specific slide
  var gridZoomBtn = e.target.closest('.refil-grid-zoom-btn');
  if (gridZoomBtn) {
    var slideIndex = parseInt(gridZoomBtn.dataset.slideIndex || 0);
    var lb = document.querySelector('.refil-lb');
    if (!lb) return;
    document.body.appendChild(lb);
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
    goToLightboxSlide(lb, slideIndex);
    return;
  }
  // View All button click
  var viewAllBtn = e.target.closest('.refil-viewall-btn');
  if (viewAllBtn) {
    var btnId = viewAllBtn.id;
    var blockId = btnId.replace('refil-viewall-', '');
    var lb = document.getElementById('refil-lb-' + blockId);
    if (!lb) return;
    document.body.appendChild(lb);
    lb.classList.add('open');
    document.body.style.overflow = 'hidden';
    goToLightboxSlide(lb, 0);
    return;
  }

  // Close button
  var closeBtn = e.target.closest('.refil-lb__close');
  if (closeBtn) {
    var lb = closeBtn.closest('.refil-lb');
    if (!lb) return;
    lb.classList.remove('open');
    document.body.style.overflow = '';
    return;
  }

  // Prev arrow
  var prevBtn = e.target.closest('.refil-lb__arrow--prev');
  if (prevBtn) {
    var lb = prevBtn.closest('.refil-lb');
    if (!lb) return;
    navigateLightbox(lb, -1);
    return;
  }

  // Next arrow
  var nextBtn = e.target.closest('.refil-lb__arrow--next');
  if (nextBtn) {
    var lb = nextBtn.closest('.refil-lb');
    if (!lb) return;
    navigateLightbox(lb, 1);
    return;
  }

  // Thumbnail click
  var thumb = e.target.closest('.refil-lb__thumb');
  if (thumb) {
    var lb = thumb.closest('.refil-lb');
    if (!lb) return;
    var index = parseInt(thumb.dataset.thumbIndex);
    goToLightboxSlide(lb, index);
    return;
  }
});

function getCurrentSlide(lb) {
  var slides = lb.querySelectorAll('.refil-lb__slide');
  for (var i = 0; i < slides.length; i++) {
    if (slides[i].classList.contains('active')) return i;
  }
  return 0;
}

function goToLightboxSlide(lb, index) {
  var slides = lb.querySelectorAll('.refil-lb__slide');
  var thumbs = lb.querySelectorAll('.refil-lb__thumb');
  var counter = lb.querySelector('.refil-lb__counter');
  var total = slides.length;
  var current = getCurrentSlide(lb);

  slides[current].classList.remove('active');
  if (thumbs[current]) thumbs[current].classList.remove('active');

  current = (index + total) % total;

  slides[current].classList.add('active');
  if (thumbs[current]) {
    thumbs[current].classList.add('active');
    thumbs[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }
  if (counter) counter.textContent = (current + 1) + ' / ' + total;
}

function navigateLightbox(lb, direction) {
  var current = getCurrentSlide(lb);
  var total = lb.querySelectorAll('.refil-lb__slide').length;
  goToLightboxSlide(lb, current + direction);
}
// Lightbox mouse drag disable
document.addEventListener('mousedown', function(e) {
  var lb = document.querySelector('.refil-lb.open');
  if (!lb) return;
  if (e.target.closest('.refil-lb__viewport')) {
    e.preventDefault();
  }
});
// Lightbox touch swipe support
(function() {
  var touchStartX = 0;
  var touchStartY = 0;

  document.addEventListener('touchstart', function(e) {
    var lb = document.querySelector('.refil-lb.open');
    if (!lb) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function(e) {
    var lb = document.querySelector('.refil-lb.open');
    if (!lb) return;
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) < 30) return;
    if (Math.abs(dy) > Math.abs(dx)) return;
    if (dx < 0) {
      navigateLightbox(lb, 1);
    } else {
      navigateLightbox(lb, -1);
    }
  }, { passive: true });
})();
// Keyboard support
document.addEventListener('keydown', function(e) {
  var lb = document.querySelector('.refil-lb.open');
  if (!lb) return;
  if (e.key === 'Escape') {
    lb.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (e.key === 'ArrowRight') navigateLightbox(lb, 1);
  if (e.key === 'ArrowLeft') navigateLightbox(lb, -1);
});

// Lightbox Zoom - Event Delegation
(function() {
  var zoomScale = 2.5;

  function getActiveSlide(lb) {
    return lb.querySelector('.refil-lb__slide.active');
  }

  function getImg(slide) {
    return slide ? slide.querySelector('.refil-lb__img') : null;
  }

  function getWrap(slide) {
    return slide ? slide.querySelector('[data-zoom-wrap]') : null;
  }

  function resetZoom(lb) {
    var slide = getActiveSlide(lb);
    var img = getImg(slide);
    var wrap = getWrap(slide);
    if (!img || !wrap) return;
    img.style.transform = 'scale(1)';
    img.style.transformOrigin = 'center center';
    img.style.transition = 'transform 0.25s ease';
    wrap.classList.remove('zoomed');
  }

  // Click to zoom
  document.addEventListener('click', function(e) {
    var viewport = e.target.closest('.refil-lb__viewport');
    if (!viewport) return;
    if (e.target.closest('.refil-lb__arrow')) return;

    var lb = viewport.closest('.refil-lb');
    if (!lb) return;

    var slide = getActiveSlide(lb);
    var img = getImg(slide);
    var wrap = getWrap(slide);
    if (!img || !wrap) return;

    if (wrap.classList.contains('zoomed')) {
      resetZoom(lb);
    } else {
      var rect = wrap.getBoundingClientRect();
      var px = ((e.clientX - rect.left) / rect.width) * 100;
      var py = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = px + '% ' + py + '%';
      img.style.transform = 'scale(' + zoomScale + ')';
      img.style.transition = 'transform 0.25s ease';
      wrap.classList.add('zoomed');
    }
  });

  // Mouse move zoom follow
  document.addEventListener('mousemove', function(e) {
    var viewport = e.target.closest('.refil-lb__viewport');
    if (!viewport) return;

    var lb = viewport.closest('.refil-lb');
    if (!lb) return;

    var slide = getActiveSlide(lb);
    var wrap = getWrap(slide);
    var img = getImg(slide);
    if (!wrap || !img) return;
    if (!wrap.classList.contains('zoomed')) return;

    var rect = wrap.getBoundingClientRect();
    var px = ((e.clientX - rect.left) / rect.width) * 100;
    var py = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transition = 'none';
    img.style.transformOrigin = px + '% ' + py + '%';
  });

  // Reset zoom on slide change
  document.addEventListener('click', function(e) {
    var arrow = e.target.closest('.refil-lb__arrow');
    var thumb = e.target.closest('.refil-lb__thumb');
    if (!arrow && !thumb) return;

    var lb = (arrow || thumb).closest('.refil-lb');
    if (!lb) return;
    setTimeout(function() { resetZoom(lb); }, 10);
  });

})();

/* =========================================================
   Custom flavour dropdown UI (thumbnails)
   Append this to the END of assets/custom.js
   ---------------------------------------------------------
   It only drives the visual dropdown. Choosing an option sets
   the hidden <select data-flavour-select> value and fires a
   'change' event, so the existing flavour fetch/history logic
   runs exactly as before. Fully delegated -> keeps working
   after main.innerHTML is replaced on flavour change.
   ========================================================= */
(function () {
  function panelOf(fdd) { return fdd.querySelector('[data-fdd-panel]'); }

  var KEEP = ['fdd__thumb', 'fdd__name', 'fdd__chev'];

  // The snippet ships hidden so it reserves no space while moveDropdown()
  // relocates it above the buy buttons. Reveal it once it is in place.
  function reveal() {
    var wrappers = document.querySelectorAll('[data-flavour-selector]');
    for (var i = 0; i < wrappers.length; i++) {
      wrappers[i].style.display = '';
      wrappers[i].style.visibility = 'visible';
    }
  }

  // custom.js drops the selector above the buy buttons, which puts it *below*
  // the Frequency (selling plan) picker. Re-parent it so it sits directly
  // before that picker instead. Runs after custom.js's mover, and again on the
  // reveal poll so an async section swap can't leave it in the old spot.
  function placeBeforeFrequency() {
    var wrappers = document.querySelectorAll('[data-flavour-selector]');
    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var container = wrapper.parentElement;
      if (!container) continue;

      var anchor = frequencyBlockIn(container);
      // Already in the right place, or no frequency picker on this page.
      if (!anchor || anchor === wrapper.nextElementSibling) continue;

      container.insertBefore(wrapper, anchor);
    }
  }

  // Find the frequency picker and climb to whichever ancestor is a direct child
  // of `container` - that is the sibling we insert before. Returns null when the
  // picker lives outside `container`, in which case placement is left alone.
  function frequencyBlockIn(container) {
    var node =
      document.querySelector(
        'input[name*="selling_plan"], select[name*="selling_plan"], [data-selling-plan-id]'
      ) || frequencyByLabel();
    if (!node) return null;

    while (node && node.parentElement !== container) node = node.parentElement;
    if (!node) return null;

    // The "Frequency: One Time" heading is a separate custom Liquid block sitting
    // just above the radios, but the two read as one control - so back up over
    // any preceding sibling that belongs to it and insert above the whole group.
    var prev = node.previousElementSibling;
    while (prev && isFrequencyLabel(prev)) {
      node = prev;
      prev = node.previousElementSibling;
    }
    return node;
  }

  function isFrequencyLabel(el) {
    if (el.hasAttribute('data-flavour-selector')) return false;
    return (el.textContent || '').trim().toLowerCase().indexOf('frequency') === 0;
  }

  // Fallback for subscription apps that don't expose a selling_plan input:
  // match the "Frequency:" label the widget renders.
  function frequencyByLabel() {
    var candidates = document.querySelectorAll(
      '.product-details legend, .product-details label, .product-details p, .product-details span'
    );
    for (var i = 0; i < candidates.length; i++) {
      var text = (candidates[i].textContent || '').trim().toLowerCase();
      if (text.indexOf('frequency') === 0) return candidates[i];
    }
    return null;
  }

  // Used after a flavour change: the new markup arrives whenever the fetch
  // finishes, so re-apply for a few seconds rather than betting on one timeout.
  var revealTimer = null;
  function revealSoon() {
    if (revealTimer) clearInterval(revealTimer);
    var tries = 0;
    revealTimer = setInterval(function () {
      sweep();
      placeBeforeFrequency();
      reveal();
      if (++tries >= 20) { clearInterval(revealTimer); revealTimer = null; }
    }, 250);
  }

  // Physically remove anything the theme/an app injects into a row.
  // CSS can be out-ranked; a removed node cannot come back.
  function sweep(scope) {
    var rows = (scope || document).querySelectorAll('.fdd__trigger, .fdd__option');
    for (var i = 0; i < rows.length; i++) {
      var kids = rows[i].children;
      for (var k = kids.length - 1; k >= 0; k--) {
        var keep = false;
        for (var c = 0; c < KEEP.length; c++) {
          if (kids[k].classList.contains(KEEP[c])) { keep = true; break; }
        }
        if (!keep) kids[k].remove();
      }
      var name = rows[i].querySelector('.fdd__name');
      if (name) {
        while (name.firstElementChild) name.firstElementChild.remove();
      }
    }
  }

  function closeDropdown(fdd) {
    if (!fdd) return;
    fdd.classList.remove('is-open');
    var trigger = fdd.querySelector('[data-fdd-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    var panel = panelOf(fdd);
    if (panel) panel.hidden = true;
  }

  function closeAll(except) {
    document.querySelectorAll('[data-fdd].is-open').forEach(function (fdd) {
      if (fdd !== except) closeDropdown(fdd);
    });
  }

  function openDropdown(fdd) {
    closeAll(fdd);
    fdd.classList.add('is-open');
    var trigger = fdd.querySelector('[data-fdd-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var panel = panelOf(fdd);
    if (!panel) return;
    panel.hidden = false;
    // Scroll the selected row into view without moving the page
    var selected = panel.querySelector('.fdd__option.is-selected');
    if (selected) {
      panel.scrollTop = Math.max(
        0,
        selected.offsetTop - (panel.clientHeight / 2) + (selected.offsetHeight / 2)
      );
    }
  }

  function options(fdd) {
    return Array.prototype.slice.call(fdd.querySelectorAll('[data-fdd-option]'));
  }

  function selectOption(option) {
    var fdd = option.closest('[data-fdd]');
    if (!fdd) return;

    var wrapper = fdd.closest('[data-flavour-selector]');
    var url = option.dataset.value;

    // Mark selection
    options(fdd).forEach(function (opt) {
      var on = opt === option;
      opt.classList.toggle('is-selected', on);
      opt.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    // Mirror the chosen option into the trigger + the "Flavor: x" label
    var srcThumb = option.querySelector('.fdd__thumb');
    var dstThumb = fdd.querySelector('[data-fdd-current-thumb]');
    if (srcThumb && dstThumb) dstThumb.innerHTML = srcThumb.innerHTML;

    var name = option.dataset.name || '';
    var dstName = fdd.querySelector('[data-fdd-current-name]');
    if (dstName) dstName.textContent = name;
    if (wrapper) {
      var labelValue = wrapper.querySelector('[data-fdd-label-value]');
      if (labelValue) labelValue.textContent = name;
    }

    closeDropdown(fdd);

    // Hand off to the existing navigation logic
    var native = fdd.querySelector('[data-flavour-select]');
    if (!native || !url) return;
    var currentPath = window.location.pathname;
    var targetPath = url;
    try { targetPath = new URL(url, window.location.origin).pathname; } catch (e) {}
    if (targetPath === currentPath) return; // already on this flavour

    native.value = url;
    native.dispatchEvent(new Event('change', { bubbles: true }));
    // The page content is swapped in async and the fetch can be slow, so keep
    // cleaning + revealing the new markup briefly instead of guessing one delay.
    revealSoon();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-fdd-trigger]');
    if (trigger) {
      var fdd = trigger.closest('[data-fdd]');
      sweep(fdd);
      if (fdd.classList.contains('is-open')) closeDropdown(fdd);
      else openDropdown(fdd);
      return;
    }

    var option = e.target.closest('[data-fdd-option]');
    if (option) {
      selectOption(option);
      return;
    }

    // Click anywhere else closes any open dropdown
    if (!e.target.closest('[data-fdd]')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    var fdd = document.querySelector('[data-fdd].is-open');

    if (e.key === 'Escape' && fdd) {
      closeDropdown(fdd);
      var trigger = fdd.querySelector('[data-fdd-trigger]');
      if (trigger) trigger.focus();
      return;
    }

    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

    // Open with arrow keys while the trigger is focused
    if (!fdd) {
      var focusedTrigger = e.target.closest && e.target.closest('[data-fdd-trigger]');
      if (!focusedTrigger) return;
      e.preventDefault();
      var target = focusedTrigger.closest('[data-fdd]');
      openDropdown(target);
      var first = target.querySelector('.fdd__option.is-selected') || target.querySelector('[data-fdd-option]');
      if (first) first.focus();
      return;
    }

    var opts = options(fdd);
    if (!opts.length) return;
    e.preventDefault();
    var index = opts.indexOf(document.activeElement);
    if (index === -1) {
      index = opts.findIndex(function (o) { return o.classList.contains('is-selected'); });
    }
    var next = e.key === 'ArrowDown' ? index + 1 : index - 1;
    if (next < 0) next = opts.length - 1;
    if (next >= opts.length) next = 0;
    opts[next].focus();
  });

  // Place before revealing so the selector never paints in the wrong slot, then
  // keep re-checking briefly - custom.js's mover may run after this listener.
  function init() {
    sweep();
    placeBeforeFrequency();
    reveal();
    revealSoon();
  }

  // Initial clean-up (and after a flavour navigation / section reload)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  window.addEventListener('popstate', function () {
    setTimeout(init, 700);
  });
  document.addEventListener('shopify:section:load', init);
})();
